export default "<m-model\n  src=\"https://public.mml.io/duck.glb\"\n  y=\"3\"\n  sx=\"3\"\n  sy=\"2\"\n  sz=\"3\"\n  ry=\"-90\"\n></m-model>\n";